import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading } from "@cinch-labs/design-system";
import { dashify } from "@cinch-labs/shared-util";
import { StoryblokRenderer } from "@cinch-nx/landing-ui-shared";
import { storyblokComponents } from "../../data/storyblok-renderer-map";
import styles from "./clause-section.module.css";
export const ClauseSection = ({ title , body  })=>/*#__PURE__*/ _jsxs("section", {
        className: styles.container,
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                element: "h2",
                className: styles.title,
                fontSize: "h1",
                id: dashify(title),
                children: title
            }),
            /*#__PURE__*/ _jsx(StoryblokRenderer, {
                block: body,
                components: storyblokComponents
            })
        ]
    });
export default ClauseSection;
